import { authAPI } from './auth';
import type { MonitoringIntent } from '../utils/monitoringIntent';

export const monitoringIntentAPI = {
  claim: (token: string) => authAPI.claimMonitoringIntent(token) as Promise<{ intent: MonitoringIntent }>,
  pending: () => authAPI.getPendingMonitoringIntent() as Promise<{ intent: MonitoringIntent | null }>,
  projectCreated: (id: string, projectId: string) => authAPI.markMonitoringIntentProjectCreated(id, projectId) as Promise<{ intent: MonitoringIntent }>,
  complete: (id: string) => authAPI.completeMonitoringIntent(id),
  dismiss: (id: string) => authAPI.dismissMonitoringIntent(id),
};
